import { Map } from 'immutable';
import { actionTypes } from './actions';

import initialState from './initialState';

export default function avatarReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_INFO:
      return Map({
        loading: true,
        error: false,
        data: null,
      });
    case actionTypes.REQUEST_SUCCESS:
      return Map({
        error: null,
        loading: false,
        data: action.payload,
      });
    case actionTypes.REQUEST_FAILURE:
      return Map({
        error: action.payload,
        loading: false,
        data: null,
      });
    default:
      return state;
  }
}
